<!-- 组件说明 -->
<template>
  <div>
    <div class="con" >
      <div >
        <div class="title">
          <h1>{{ title }}</h1>
        </div>
        <div class="meal-container">
          <div class="box-left">
            <img v-lazy=" $defaultImg" alt="" />
          </div>
          <div class="box-right">
            <div class="t">
              <div class="t-item">
                <h3>补肾健脑套餐</h3>
                <p>套餐价格：¥610.00</p>
                <div class="save-img">立省40.00元</div>
                <div class="item-img">
                  <img :src="require('@/assets/images/icon_chart.png')" alt="" />
                </div>
              </div>
            </div>
            <div class="b">
              <div class="b-item">
                <div class="left">
                  <h3>补肾健脑套餐</h3>
                  <i></i>
                  <p>套餐价格：¥610.00</p>
                  <div class="save-img">立省40.00元</div>
                </div>
                <div class="right">
                  <div class="right-img">
                    <img :src="require('@/assets/images/icon_chart.png')" alt="" />
                  </div>
                  <div class="right-img">
                    <img :src="require('@/assets/images/icon_chart.png')" alt="" />
                  </div>
                </div>
              </div>
              <div class="b-item">
                <div class="left">
                  <h3>补肾健脑套餐</h3>
                  <i></i>
                  <p>套餐价格：¥610.00</p>
                  <div class="save-img">立省40.00元</div>
                </div>
                <div class="right">
                  <div class="right-img">
                    <img :src="require('@/assets/images/icon_chart.png')" alt="" />
                  </div>
                  <div class="right-img">
                    <img :src="require('@/assets/images/icon_chart.png')" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import x from ''
export default {
  components: {},
  data() {
    return {
      title:"套餐促销",
     
    };
  },
  computed: {},
  methods: {

  },
  mounted() {},
  created() {

  },
};
</script>

<style lang='scss' scoped>
.title h1 {
  font-size: 28px;
  color: #333333;
  margin: 38px 0 20px 0;
}
.meal-container {
  display: flex;
  .box-left {
    width: 232px;
    height: 466px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    img {
      @include size(100%, 100%);
    }
  }
  .box-right {
    .t {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      overflow: hidden;
      .t-item {
        width: 232px;
        height: 294px;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 4px;
        overflow: hidden;
        background-color: #ffffff;
        flex-shrink: 0;
        &:nth-child(n):not(:last-child) {
          margin-right: 10px;
        }
        h3 {
          font-size: 16px;
          color: #505050;
          margin: 26px 0 12px 0;
        }
        p {
          font-size: 14px;
          color: #505050;
        }
        .save-img {
          background: url("../../../../assets/images/icon_province.png")
            no-repeat;
          text-align: center;
          font-size: 12px;
          color: #ffffff;
          height: 30px;
          line-height: 32px;
          margin: 12px 0 4px 0;
          padding: 0 5px;
        }
        .item-img {
          width: 180px;
          height: 180px;
          img {
            @include size(100%, 100%);
          }
        }
      }
    }
  }
}
.b {
  display: flex;
  justify-content: space-between;
  .b-item {
    display: flex;
    width: 474px;
    height: 163px;
    background-color: #ffffff;
    padding: 0 22px;
    justify-content: space-between;
  }
  .left {
    color: #505050;
    h3 {
      font-size: 16px;
      margin: 34px 0 12px 0;
    }
    i {
      display: block;
      height: 3px;
      width: 14px;
      background-color: #505050;
    }
    p {
      font-size: 14px;
      margin: 12px 0 10px 0;
    }
    .save-img {
      background: url("../../../../assets/images/icon_province.png") no-repeat;
      font-size: 12px;
      color: #ffffff;
      height: 30px;
      line-height: 32px;
      padding: 0 5px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    .right-img {
      width: 116px;
      height: 116px;
      margin-left: 10px;
      img {
        @include size(100%, 100%);
      }
      &:hover {
        transform: translateY(5px);
        box-shadow: 0 0 10px 12px #e5e5e5;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/meal/components/goods-meal.vue